import { createRouter } from "@tanstack/react-router";
import { routeTree } from "../routeTree.gen";
import PageNotFound from "../components/PageNotFound";

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: PageNotFound,
});
